import { useMemo } from 'react';
import styled from '@emotion/styled';

// colors
import { primary } from '@styles/Colors';

// icons
import Icon from '../Icon';

// constants
import { Radius } from '@styles/Radius';
import { AlertIconType } from '@constants/atoms';

type Props = {
  iconType?: AlertIconType;
  width?: string;
  children?: React.ReactNode;
};

const AlertWrapper = styled.div<Props>`
  border-radius: ${Radius.MEDIUM};
  background: rgba(13, 79, 222, 0.04);
  padding: 16px;

  display: flex;
  gap: 8px;
  align-items: center;
`;

const DEFAULT_WIDTH = '100%';

export default function AlertComponent({ width = DEFAULT_WIDTH, iconType = AlertIconType.WARNING, children }: Props) {
  const iconName = useMemo(() => {
    switch (iconType) {
      case AlertIconType.WARNING:
        return 'alert-triangle';
      case AlertIconType.FOCUS:
        return 'alert-circle';
      case AlertIconType.BULB:
        return 'noti-light-on';
      case AlertIconType.QUESTION:
        return 'alert-question';
      case AlertIconType.CHECK:
        return 'check-circle-blue';
    }
  }, [iconType]);

  return (
    <AlertWrapper style={{ width }}>
      <Icon name={iconName} stroke={primary.blue} />
      {children}
    </AlertWrapper>
  );
}
